export enum GenerationRequestStatus {
  Submitted = 1,
  InProgress,
  Finished,
  Cancelled,
  Rejected,
  Failed,
}
